import { InteractionType } from "../../models/interactions/Interaction";
import { StringUtils } from "../utils/StringUtils";

export enum InteractionCategory {
  Popups = "Popups",
  Quizes = "Quizes",
  Other = "Other",
  ThreeD = "ThreeD",
}

export enum InteractionIcon {
  Message = "message",
  Image = "image",
  Video = "video",
  Pdf = "pdf",
  MultipleChoiceQuiz = "multipleChoiceQuiz",
  MultiselectQuiz = "multiselectQuiz",
  OrderQuiz = "orderQuiz",
  ConnectQuiz = "connectQuiz",
  Marker = "marker",
  WordSpinnerQuiz = "wordSpinnerQuiz",
  ClickRegion = "clickRegion",
  PhotoRangeQuiz = "photoRangeQuiz",
  AmbientAudio = "ambientAudio",
  AudioPopup = "audioPopup",
  Camera = "camera",
  Prop = "prop",
  PowerSlide = "powerSlide",
}

export interface InteractionDefintion {
  name: string;
  description: string;
  icon: InteractionIcon;
  type: InteractionType;
  category: InteractionCategory;
  previewImage: string;
  createParams?: { operator?: string };
  searchAliases?: string[];
}

const LisaMessageDefinition: InteractionDefintion = {
  name: "Lisa Message",
  description: "lisa_message",
  icon: InteractionIcon.Message,
  type: InteractionType.LisaMessage,
  category: InteractionCategory.Other,
  previewImage: "lisa_message.png",
};

const MessagePopupDefinition: InteractionDefintion = {
  name: "Message Popup",
  description: "message_popup",
  icon: InteractionIcon.Message,
  type: InteractionType.MessagePopup,
  category: InteractionCategory.Popups,
  previewImage: "message_popup.png",
};

const ImagePopupDefinition: InteractionDefintion = {
  name: "Image Popup",
  description: "image_popup",
  icon: InteractionIcon.Image,
  type: InteractionType.ImagePopup,
  category: InteractionCategory.Popups,
  previewImage: "image_popup.png",
};

const VideoPopupDefinition: InteractionDefintion = {
  name: "Video Popup",
  description: "video_popup",
  icon: InteractionIcon.Video,
  type: InteractionType.VideoPopup,
  category: InteractionCategory.Popups,
  previewImage: "video_popup.png",
};

const PdfPopupDefinition: InteractionDefintion = {
  name: "Pdf Popup",
  description: "pdf_popup",
  icon: InteractionIcon.Pdf,
  type: InteractionType.PdfPopup,
  category: InteractionCategory.Popups,
  previewImage: "pdf_preview.png",
};

const MultipleChoiceQuizDefinition: InteractionDefintion = {
  name: "Multiple Choice Quiz",
  description: "multiple_choice_quiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.MultipleChoiceQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "multiple_choice_quiz.png",
};

const MultiselectQuizDefinition: InteractionDefintion = {
  name: "MultiSelect Quiz",
  description: "multi_select_quiz",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.MultiselectQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "multiselect_quiz.png",
};

const MultipleChoiceGraphicsQuizDefinition: InteractionDefintion = {
  name: "Multiple Choice Graphics Quiz",
  description: "multiple_choice_gfx_quiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.MultipleChoiceGraphicsQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "multiple_choice_graphics_quiz.png",
};

const MultiSelectGraphicsQuizDefinition: InteractionDefintion = {
  name: "MultiSelect Graphics Quiz",
  description: "multi_select_gfx_quiz",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.MultiSelectGraphicsQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "multiselect_graphics_quiz.png",
};

const OrderQuizDefinition: InteractionDefintion = {
  name: "Order Quiz",
  description: "order_quiz",
  icon: InteractionIcon.OrderQuiz,
  type: InteractionType.OrderQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "order_quiz.png",
};

const OrderGraphicsQuizDefinition: InteractionDefintion = {
  name: "Order Graphics Quiz",
  description: "order_gfx_quiz",
  icon: InteractionIcon.OrderQuiz,
  type: InteractionType.OrderGraphicsQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "order_graphics_quiz.png",
};

const ConnectQuizDefinition: InteractionDefintion = {
  name: "Connect Quiz",
  description: "connect_quiz",
  icon: InteractionIcon.ConnectQuiz,
  type: InteractionType.ConnectQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "connect_quiz.png",
};

const ConnectGraphicsQuizDefinition: InteractionDefintion = {
  name: "Connect Graphics Quiz",
  description: "connect_gfx_quiz",
  icon: InteractionIcon.ConnectQuiz,
  type: InteractionType.ConnectGraphicsQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "connect_graphics_quiz.png",
};

const LabelDragAndDropQuizDefinition: InteractionDefintion = {
  name: "Label Drag And Drop Quiz",
  description: "label_drag_and_drop_quiz",
  icon: InteractionIcon.ConnectQuiz,
  type: InteractionType.LabelDragAndDropQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "label_dnd_quiz_preview.png",
};

const PropLabelQuizDefinition: InteractionDefintion = {
  name: "Prop Label Quiz",
  description: "prop_label_quiz",
  icon: InteractionIcon.Prop,
  type: InteractionType.PropLabelQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "coming_soon.png",
};

const PropLabelOrderQuizDefinition: InteractionDefintion = {
  name: "Prop Label Order Quiz",
  description: "prop_label_order_quiz",
  icon: InteractionIcon.Prop,
  type: InteractionType.PropLabelOrderQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "coming_soon.png",
};

const ImageDragAndDropQuizDefinition: InteractionDefintion = {
  name: "Image Drag And Drop Quiz",
  description: "image_drag_and_drop_quiz",
  icon: InteractionIcon.Image,
  type: InteractionType.ImageDragAndDropQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "image_dnd_quiz_preview.png",
};

const MarkerDefinition: InteractionDefintion = {
  name: "Marker",
  description: "marker",
  icon: InteractionIcon.Marker,
  type: InteractionType.Marker,
  category: InteractionCategory.Other,
  previewImage: "marker.png",
};

const ScrabbleQuizDefinition: InteractionDefintion = {
  name: "Scrabble Quiz",
  description: "scrabble_quiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.ScrabbleQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "scrabble_quiz.png",
};

const WordSpinnerQuizDefinition: InteractionDefintion = {
  name: "Word Spinner Quiz",
  description: "wordspinner_quiz",
  icon: InteractionIcon.WordSpinnerQuiz,
  type: InteractionType.WordSpinnerQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "word_spinner_quiz.png",
};

const ClickRegionDefinition: InteractionDefintion = {
  name: "Click Region",
  description: "clickregion",
  icon: InteractionIcon.ClickRegion,
  type: InteractionType.ClickRegion,
  category: InteractionCategory.Other,
  previewImage: "click_region.png",
};

const ClickRegionOrderQuizDefinition: InteractionDefintion = {
  name: "Click Region Order Quiz",
  description: "clickregion_order_quiz",
  icon: InteractionIcon.ClickRegion,
  type: InteractionType.ClickRegionOrderQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "clickregion_order_quiz.png",
};

const ClickRegionMultiSelectQuizDefinition: InteractionDefintion = {
  name: "Click Region Multiple Choice Quiz",
  description: "clickregion_multi_select_quiz",
  icon: InteractionIcon.ClickRegion,
  type: InteractionType.ClickRegionMultiSelectQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "clickregion_ms_quiz.png",
};

const WordQuizDefinition: InteractionDefintion = {
  name: "Word Quiz",
  description: "word_quiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.WordQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "word_quiz.png",
};

const PhotoRangeQuizDefinition: InteractionDefintion = {
  name: "Photo Range Quiz",
  description: "photorange_quiz",
  icon: InteractionIcon.PhotoRangeQuiz,
  type: InteractionType.PhotoRangeQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "photo_range_quiz.png",
};

const AmbientAudioDefinition: InteractionDefintion = {
  name: "Ambient Audio",
  description: "ambient_audio",
  icon: InteractionIcon.AmbientAudio,
  type: InteractionType.AmbientAudio,
  category: InteractionCategory.Other,
  previewImage: "ambient_audio.png",
};

const AudioPopupDefinition: InteractionDefintion = {
  name: "Audio Popup",
  description: "audio_popup",
  icon: InteractionIcon.AudioPopup,
  type: InteractionType.AudioPopup,
  category: InteractionCategory.Popups,
  previewImage: "audio_popup.png",
};

const ConversationDefinition: InteractionDefintion = {
  name: "Conversation",
  description: "conversation",
  icon: InteractionIcon.Message,
  type: InteractionType.Conversation,
  category: InteractionCategory.Popups,
  previewImage: "conversation.png",
};

const SetCameraDefinition: InteractionDefintion = {
  name: "Set Camera",
  description: "camera",
  icon: InteractionIcon.Camera,
  type: InteractionType.SetCamera,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const MessageBubbleDefinition: InteractionDefintion = {
  name: "Message Bubble",
  description: "messageBubble",
  icon: InteractionIcon.Message,
  type: InteractionType.MessageBubble,
  category: InteractionCategory.Other,
  previewImage: "message_bubble_preview.png",
};

const EmotionBubbleDefintion: InteractionDefintion = {
  name: "Emotion Bubble",
  description: "emotionBubble",
  icon: InteractionIcon.Message,
  type: InteractionType.EmotionBubble,
  category: InteractionCategory.Other,
  previewImage: "emotion_bubble_preview.png",
};

const DialogQuizDefinition: InteractionDefintion = {
  name: "Dialog Quiz",
  description: "dialogQuiz",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.DialogQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "dialog_quiz.png",
};

const GrabDefinition: InteractionDefintion = {
  name: "Grab",
  description: "grab",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.Grab,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const DetachDefinition: InteractionDefintion = {
  name: "Detach",
  description: "detach",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.Detach,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const AttachDefinition: InteractionDefintion = {
  name: "Attach",
  description: "attach",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.Attach,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const SlideshowDefinition: InteractionDefintion = {
  name: "Slideshow",
  description: "slideshow",
  icon: InteractionIcon.Image,
  type: InteractionType.Slideshow,
  category: InteractionCategory.Popups,
  previewImage: "slideshow.png",
};

const ButtonsQuiz: InteractionDefintion = {
  name: "Button Quiz",
  description: "buttonQuiz",
  icon: InteractionIcon.MultiselectQuiz,
  type: InteractionType.ButtonsQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "buttons_quiz.png",
};

const LookatDefinition: InteractionDefintion = {
  name: "Look At",
  description: "lookat",
  icon: InteractionIcon.Camera,
  type: InteractionType.Lookat,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const SetPropState: InteractionDefintion = {
  name: "Set Prop State",
  description: "setpropstate",
  icon: InteractionIcon.Prop,
  type: InteractionType.SetPropState,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ShowUIProp: InteractionDefintion = {
  name: "Show UI Prop",
  description: "showuiprop",
  icon: InteractionIcon.Prop,
  type: InteractionType.ShowUIProp,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const HideUIProp: InteractionDefintion = {
  name: "Hide UI Prop",
  description: "showuiprop",
  icon: InteractionIcon.Prop,
  type: InteractionType.HideUIProp,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ImageButtonsQuiz: InteractionDefintion = {
  name: "Image Button Quiz",
  description: "imagebuttonquiz",
  icon: InteractionIcon.Prop,
  type: InteractionType.ImageButtonQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "image_buttons_quiz.png",
};

const ClickIndicator: InteractionDefintion = {
  name: "Click Indicator",
  description: "clickindicator",
  icon: InteractionIcon.Prop,
  type: InteractionType.ClickIndicator,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const HideClickIndicator: InteractionDefintion = {
  name: "Hide Click Indicator",
  description: "hideClickIndicator",
  icon: InteractionIcon.Prop,
  type: InteractionType.HideClickIndicator,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const WaitForClickDefinition: InteractionDefintion = {
  name: "Wait For Click",
  description: "waitForClick",
  icon: InteractionIcon.Prop,
  type: InteractionType.WaitForClick,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ShowCustomQuizDefinition: InteractionDefintion = {
  name: "Show Custom Quiz",
  description: "showCustomQuiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.ShowCustomQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "coming_soon.png",
};

const LoseCustomQuizStarDefinition: InteractionDefintion = {
  name: "Lose Custom Quiz Star",
  description: "loseCustomQuizStar",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.LoseCustomQuizStar,
  category: InteractionCategory.Quizes,
  previewImage: "coming_soon.png",
};

const CloseCustomQuizDefinition: InteractionDefintion = {
  name: "Close Custom Quiz",
  description: "closeCustomQuiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.CloseCustomQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "coming_soon.png",
};

const StatementQuiz: InteractionDefintion = {
  name: "Statement Quiz",
  description: "statementquiz",
  icon: InteractionIcon.MultipleChoiceQuiz,
  type: InteractionType.StatementQuiz,
  category: InteractionCategory.Quizes,
  previewImage: "statement_quiz.png",
};

const InspectPropDefinition: InteractionDefintion = {
  name: "Inspect Prop",
  description: "",
  icon: InteractionIcon.Camera,
  type: InteractionType.InspectProp,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const WaitDefinition: InteractionDefintion = {
  name: "Wait",
  description: "wait",
  icon: InteractionIcon.Prop,
  type: InteractionType.Wait,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const SetCharacterPartsDefinition: InteractionDefintion = {
  name: "Set Character Parts",
  description: "setCharacterParts",
  icon: InteractionIcon.Prop,
  type: InteractionType.SetCharacterParts,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ClearCharacterPartsDefinition: InteractionDefintion = {
  name: "Clear Character Parts",
  description: "clearCharacterParts",
  icon: InteractionIcon.Prop,
  type: InteractionType.ClearCharacterParts,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const SequenceDefinition: InteractionDefintion = {
  name: "Sequence",
  description: "sequence",
  icon: InteractionIcon.Prop,
  type: InteractionType.Sequence,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ParallelSequenceDefinition: InteractionDefintion = {
  name: "Parallel Sequence",
  description: "parallel_sequence",
  icon: InteractionIcon.Prop,
  type: InteractionType.ParallelSequence,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const AnimateActorDefinition: InteractionDefintion = {
  name: "Animate Actor",
  description: "animateActor",
  icon: InteractionIcon.Prop,
  type: InteractionType.AnimateActor,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const StopWalkingDefinition: InteractionDefintion = {
  name: "Stop Walking",
  description: "stopWalking",
  icon: InteractionIcon.Prop,
  type: InteractionType.StopWalking,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ProximityTriggerDefinition: InteractionDefintion = {
  name: "Proximity Trigger",
  description: "proximityTrigger",
  icon: InteractionIcon.Prop,
  type: InteractionType.ProximityTrigger,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const SendActorToPositionDefinition: InteractionDefintion = {
  name: "Send Actor to Position",
  description: "sendActorToPosition",
  icon: InteractionIcon.Prop,
  type: InteractionType.SendActorToPosition,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const SubSequenceDefinition: InteractionDefintion = {
  name: "Sub Sequence",
  description: "subSequence",
  icon: InteractionIcon.Prop,
  type: InteractionType.SubSequence,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const PlaySubSequenceDefinition: InteractionDefintion = {
  name: "Play Sub Sequence",
  description: "playSubSequence",
  icon: InteractionIcon.Prop,
  type: InteractionType.PlaySubSequence,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const StopSubSequenceDefinition: InteractionDefintion = {
  name: "Stop Sub Sequence",
  description: "stopSubSequence",
  icon: InteractionIcon.Prop,
  type: InteractionType.StopSubSequence,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const setOutfitInteraction: InteractionDefintion = {
  name: "Set Outfit",
  description: "---",
  icon: InteractionIcon.Prop,
  type: InteractionType.SetOutfit,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};
const TriggerEventDefinition: InteractionDefintion = {
  name: "Trigger Event",
  description: "triggerEvent",
  icon: InteractionIcon.Prop,
  type: InteractionType.TriggerEvent,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const WaitForEventDefinition: InteractionDefintion = {
  name: "Wait for Event",
  description: "waitForEvent",
  icon: InteractionIcon.Prop,
  type: InteractionType.WaitForEvent,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const InitializeTimerDefinition: InteractionDefintion = {
  name: "Initialize Timer",
  description: "initializeTimer",
  icon: InteractionIcon.Prop,
  type: InteractionType.InitializeTimer,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const UpdateTimerDefinition: InteractionDefintion = {
  name: "Update Timer",
  description: "updateTimer",
  icon: InteractionIcon.Prop,
  type: InteractionType.UpdateTimer,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const GetTimerTimeDefinition: InteractionDefintion = {
  name: "Get Timer Time",
  description: "getTimerTime",
  icon: InteractionIcon.Prop,
  type: InteractionType.GetTimerTime,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const TransitionDefinition: InteractionDefintion = {
  name: "Transition",
  description: "transition",
  icon: InteractionIcon.Prop,
  type: InteractionType.Transition,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const ShowLetterBoxDefinition: InteractionDefintion = {
  name: "Show Letter Box",
  description: "showLetterBox",
  icon: InteractionIcon.Prop,
  type: InteractionType.ShowLetterBox,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const HideLetterBoxDefinition: InteractionDefintion = {
  name: "Hide Letter Box",
  description: "hideLetterBox",
  icon: InteractionIcon.Prop,
  type: InteractionType.HideLetterBox,
  category: InteractionCategory.ThreeD,
  previewImage: "coming_soon.png",
};

const IfEqualDefinition: InteractionDefintion = {
  name: "Equal",
  description: "if",
  icon: InteractionIcon.Prop,
  type: InteractionType.If,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "EQUAL" },
  searchAliases: ["="],
};

const IfNotEqualDefinition: InteractionDefintion = {
  name: "Not Equal",
  description: "if",
  icon: InteractionIcon.Prop,
  type: InteractionType.If,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "NOTEQUAL" },
  searchAliases: ["!=", "<>"],
};

const IfLessDefinition: InteractionDefintion = {
  name: "Less",
  description: "if",
  icon: InteractionIcon.Prop,
  type: InteractionType.If,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "LESS" },
  searchAliases: ["<"],
};

const IfLessOrEqualDefinition: InteractionDefintion = {
  name: "Less or Equal",
  description: "if",
  icon: InteractionIcon.Prop,
  type: InteractionType.If,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "LEQUAL" },
  searchAliases: ["<=", "=<"],
};

const IfGreaterDefinition: InteractionDefintion = {
  name: "Greater",
  description: "if",
  icon: InteractionIcon.Prop,
  type: InteractionType.If,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "GREATER" },
  searchAliases: [">"],
};

const IfGreaterOrEqualDefinition: InteractionDefintion = {
  name: "Greater or Equal",
  description: "if",
  icon: InteractionIcon.Prop,
  type: InteractionType.If,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "GEQUAL" },
  searchAliases: [">=", "=>"],
};

const SwitchDefinition: InteractionDefintion = {
  name: "Switch",
  description: "switch",
  icon: InteractionIcon.Prop,
  type: InteractionType.Switch,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const MathAddDefinition: InteractionDefintion = {
  name: "Add",
  description: "math",
  icon: InteractionIcon.Prop,
  type: InteractionType.Math,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "ADD" },
  searchAliases: ["+"],
};

const MathSubtractDefinition: InteractionDefintion = {
  name: "Subtract",
  description: "math",
  icon: InteractionIcon.Prop,
  type: InteractionType.Math,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "SUBTRACT" },
  searchAliases: ["-"],
};

const MathMultiplyDefinition: InteractionDefintion = {
  name: "Multiply",
  description: "math",
  icon: InteractionIcon.Prop,
  type: InteractionType.Math,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "MULTIPLY" },
  searchAliases: ["*", "x"],
};

const MathDivideDefinition: InteractionDefintion = {
  name: "Divide",
  description: "math",
  icon: InteractionIcon.Prop,
  type: InteractionType.Math,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "DIVIDE" },
  searchAliases: ["/"],
};

const MathModuloDefinition: InteractionDefintion = {
  name: "Modulo",
  description: "math",
  icon: InteractionIcon.Prop,
  type: InteractionType.Math,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
  createParams: { operator: "MODULO" },
  searchAliases: ["%"],
};

const SetVariableDefinition: InteractionDefintion = {
  name: "Set Variable",
  description: "setVariable",
  icon: InteractionIcon.Prop,
  type: InteractionType.SetVariable,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const SetMovementEnabledDefinition: InteractionDefintion = {
  name: "Set Movement Enabled",
  description: "setMovementEnabled",
  icon: InteractionIcon.Prop,
  type: InteractionType.SetMovementEnabled,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const EnableDefaultCameraDefinition: InteractionDefintion = {
  name: "Enable Default Camera",
  description: "enableDefaultCamera",
  icon: InteractionIcon.Camera,
  type: InteractionType.EnableDefaultCamera,
  category: InteractionCategory.Other,
  previewImage: "coming_soon.png",
};

const PowerSlideDefinition: InteractionDefintion = {
  name: "PowerSlide",
  description: "power_slide",
  icon: InteractionIcon.PowerSlide,
  type: InteractionType.PowerSlide,
  category: InteractionCategory.Other,
  previewImage: "power_slide.png",
  searchAliases: ["slides", "deck", "presentation"],
};

// TODO: do this differently

export const BasicInteractions360 = [
  MessagePopupDefinition,
  LisaMessageDefinition,
  ImagePopupDefinition,
  VideoPopupDefinition,
  PdfPopupDefinition,
  MultipleChoiceQuizDefinition,
  MultiselectQuizDefinition,
  MultipleChoiceGraphicsQuizDefinition,
  MultiSelectGraphicsQuizDefinition,
  OrderQuizDefinition,
  OrderGraphicsQuizDefinition,
  ConnectQuizDefinition,
  ConnectGraphicsQuizDefinition,
  LabelDragAndDropQuizDefinition,
  ImageDragAndDropQuizDefinition,
  MarkerDefinition,
  ScrabbleQuizDefinition,
  WordSpinnerQuizDefinition,
  ClickRegionDefinition,
  ClickRegionOrderQuizDefinition,
  ClickRegionMultiSelectQuizDefinition,
  WordQuizDefinition,
  PhotoRangeQuizDefinition,
  AmbientAudioDefinition,
  AudioPopupDefinition,
  SlideshowDefinition,
  ButtonsQuiz,
  ImageButtonsQuiz,
  StatementQuiz,
  PowerSlideDefinition,
];

export const BasicInteractions3D = [
  MessagePopupDefinition,
  LisaMessageDefinition,
  ImagePopupDefinition,
  VideoPopupDefinition,
  PdfPopupDefinition,
  MultipleChoiceQuizDefinition,
  MultiselectQuizDefinition,
  MultipleChoiceGraphicsQuizDefinition,
  MultiSelectGraphicsQuizDefinition,
  OrderQuizDefinition,
  OrderGraphicsQuizDefinition,
  ConnectQuizDefinition,
  ConnectGraphicsQuizDefinition,
  LabelDragAndDropQuizDefinition,
  PropLabelQuizDefinition,
  PropLabelOrderQuizDefinition,
  ImageDragAndDropQuizDefinition,
  ScrabbleQuizDefinition,
  WordSpinnerQuizDefinition,
  WordQuizDefinition,
  PhotoRangeQuizDefinition,
  AmbientAudioDefinition,
  AudioPopupDefinition,
  ConversationDefinition,
  MessageBubbleDefinition,
  EmotionBubbleDefintion,
  DialogQuizDefinition,
  DetachDefinition,
  AttachDefinition,
  SlideshowDefinition,
  ButtonsQuiz,
  LookatDefinition,
  SetPropState,
  ShowUIProp,
  HideUIProp,
  ImageButtonsQuiz,
  ClickIndicator,
  StatementQuiz,
  SetCameraDefinition,
  InspectPropDefinition,
  WaitDefinition,
  SetCharacterPartsDefinition,
  ClearCharacterPartsDefinition,
  TransitionDefinition,
  SequenceDefinition,
  AnimateActorDefinition,
  setOutfitInteraction,
  PowerSlideDefinition,
];

export const AllInteractions = [
  MessagePopupDefinition,
  LisaMessageDefinition,
  ImagePopupDefinition,
  VideoPopupDefinition,
  PdfPopupDefinition,
  MultipleChoiceQuizDefinition,
  MultiselectQuizDefinition,
  MultipleChoiceGraphicsQuizDefinition,
  MultiSelectGraphicsQuizDefinition,
  OrderQuizDefinition,
  OrderGraphicsQuizDefinition,
  ConnectQuizDefinition,
  ConnectGraphicsQuizDefinition,
  LabelDragAndDropQuizDefinition,
  PropLabelQuizDefinition,
  PropLabelOrderQuizDefinition,
  ImageDragAndDropQuizDefinition,
  MarkerDefinition,
  ScrabbleQuizDefinition,
  WordSpinnerQuizDefinition,
  ClickRegionDefinition,
  ClickRegionOrderQuizDefinition,
  ClickRegionMultiSelectQuizDefinition,
  WordQuizDefinition,
  PhotoRangeQuizDefinition,
  AmbientAudioDefinition,
  AudioPopupDefinition,
  ConversationDefinition,
  SetCameraDefinition,
  InspectPropDefinition,
  MessageBubbleDefinition,
  EmotionBubbleDefintion,
  DialogQuizDefinition,
  GrabDefinition,
  DetachDefinition,
  AttachDefinition,
  SlideshowDefinition,
  ButtonsQuiz,
  LookatDefinition,
  SetPropState,
  ShowUIProp,
  HideUIProp,
  ImageButtonsQuiz,
  ClickIndicator,
  HideClickIndicator,
  WaitForClickDefinition,
  StatementQuiz,
  LoseCustomQuizStarDefinition,
  CloseCustomQuizDefinition,
  WaitDefinition,
  SetCharacterPartsDefinition,
  ClearCharacterPartsDefinition,
  TransitionDefinition,
  SequenceDefinition,
  AnimateActorDefinition,
  PowerSlideDefinition,
];

// curated subsets offered inside quiz feedback sections — feedback-suitable
// interactions only (no quizzes, markers, or flow control)
export const FeedbackSelectableDefinitions360 = [
  MessagePopupDefinition,
  LisaMessageDefinition,
  ImagePopupDefinition,
  VideoPopupDefinition,
  PdfPopupDefinition,
  AudioPopupDefinition,
  SlideshowDefinition,
];

export const FeedbackSequenceDefinitions = [
  SequenceDefinition,
];

export const FeedbackSelectableDefinitions3D = [
  ...FeedbackSelectableDefinitions360,
  ConversationDefinition,
  MessageBubbleDefinition,
  EmotionBubbleDefintion,
  ...FeedbackSequenceDefinitions,
];

export const SequenceSelectableDefinitions = [
  SetPropState,
  LisaMessageDefinition,
  MessageBubbleDefinition,
  EmotionBubbleDefintion,
  WaitDefinition,
  InspectPropDefinition,
  ClickIndicator,
  HideClickIndicator,
  WaitForClickDefinition,
  SetCameraDefinition,
  AnimateActorDefinition,
  StopWalkingDefinition,
  ProximityTriggerDefinition,
  SendActorToPositionDefinition,
  SubSequenceDefinition,
  PlaySubSequenceDefinition,
  StopSubSequenceDefinition,
  ParallelSequenceDefinition,
  AttachDefinition,
  DetachDefinition,
  TriggerEventDefinition,
  setOutfitInteraction,
  WaitForEventDefinition,
  InitializeTimerDefinition,
  UpdateTimerDefinition,
  GetTimerTimeDefinition,
  SetCharacterPartsDefinition,
  TransitionDefinition,
  ShowLetterBoxDefinition,
  HideLetterBoxDefinition,
  ShowCustomQuizDefinition,
  LoseCustomQuizStarDefinition,
  CloseCustomQuizDefinition,
  IfEqualDefinition,
  IfNotEqualDefinition,
  IfLessDefinition,
  IfLessOrEqualDefinition,
  IfGreaterDefinition,
  IfGreaterOrEqualDefinition,
  SwitchDefinition,
  MathAddDefinition,
  MathSubtractDefinition,
  MathMultiplyDefinition,
  MathDivideDefinition,
  MathModuloDefinition,
  SetVariableDefinition,
  SetMovementEnabledDefinition,
  EnableDefaultCameraDefinition,
  LookatDefinition,
];

/**
 * Whether two definitions describe the same offering. `type` alone is not
 * enough — the comparison/maths definitions all share one type and differ only
 * by operator — and `name` is not stable enough, which is what the old
 * "most recent" copies worked around by appending a space.
 */
export const isSameInteractionDefinition = (
  a: InteractionDefintion | undefined,
  b: InteractionDefintion | undefined
): boolean => {
  if (!a || !b) return false;

  return (
    a.type === b.type && a.createParams?.operator === b.createParams?.operator
  );
};

/**
 * Everything a search query is matched against for one definition. Single
 * source of truth so the picker, the sequence context menu and any later
 * browse dialog all agree on what "searchable" means.
 */
export const getInteractionSearchStrings = (
  definition: InteractionDefintion
): string[] => [definition.name, ...(definition.searchAliases ?? [])];

/**
 * Subsequence match on name and aliases — typing "deck" finds PowerSlide.
 * Returns the input array untouched for an empty filter so callers that
 * memoise on identity do not see a new array on every keystroke.
 */
export const filterInteractionDefinitions = (
  definitions: InteractionDefintion[],
  filter: string
): InteractionDefintion[] => {
  if (!filter) return definitions;

  return definitions.filter((definition) =>
    StringUtils.SubsequenceMatchAny(
      filter,
      getInteractionSearchStrings(definition)
    )
  );
};
